import { useEffect } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { useAppStore } from 'v2/state/app'
import { primaryEventBus, PrimaryEvents } from 'v2/utils/event-bus/primary'

const INACTIVE_THRESHOLD_MINUTES = 5

export function useTabManager() {
  const { isIdle, getTabId, isLastActiveTab } = useIdleTimer({
    timeout: INACTIVE_THRESHOLD_MINUTES * 60 * 1000,
    throttle: 500,
    events: ['visibilitychange'],
    crossTab: true,
    name: 'tab-manager',
    onActive: (_x, idleTimer) => {
      primaryEventBus.emit(PrimaryEvents.APP_ACTIVE, idleTimer?.getLastActiveTime()?.getTime() ?? 0)
    },
    onIdle: () => {
      primaryEventBus.emit(PrimaryEvents.APP_INACTIVE)
    },
    onAction: (event) => {
      if (event?.type === 'visibilitychange') {
        primaryEventBus.emit(PrimaryEvents.APP_FOCUSED, !document.hidden)
        useAppStore.getState().setAppFocused(!document.hidden)
        if (!document.hidden) {
          localStorage.setItem('LAST_USED_TAB', getTabId())
        }
      }
    },
  })
  const isLastUsedTab = () => {
    const lastTab = localStorage.getItem('LAST_USED_TAB')
    return lastTab ? lastTab === getTabId() : isLastActiveTab()
  }

  useEffect(() => {
    localStorage.setItem('LAST_USED_TAB', getTabId())
    window.cx.tabManager = {
      isLastActiveTab,
      getTabId,
      isLastUsedTab,
    }
    const unloadHandler = () => localStorage.removeItem('LAST_USED_TAB')
    window.addEventListener('beforeunload', unloadHandler)
    return () => {
      window.removeEventListener('beforeunload', unloadHandler)
    }
  }, [])

  return { isIdle, getTabId, isLastActiveTab }
}
